var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#EEF7EC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1194_1778)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.23873 17.1877C8.12571 17.1877 8.01732 17.1428 7.9374 17.0629C7.85749 16.983 7.81259 16.8746 7.81259 16.7616V8.23885C7.81259 8.12583 7.85749 8.01744 7.9374 7.93752C8.01732 7.85761 8.12571 7.81271 8.23873 7.81271H16.1222C16.2918 7.81271 16.4544 7.74537 16.5742 7.62549C16.6941 7.50562 16.7615 7.34303 16.7615 7.17351C16.7615 7.00398 16.6941 6.84139 16.5742 6.72152C16.4544 6.60165 16.2918 6.5343 16.1222 6.5343H8.23873C7.78665 6.5343 7.35309 6.71389 7.03343 7.03355C6.71377 7.35322 6.53418 7.78677 6.53418 8.23885V16.7616C6.53418 17.2136 6.71377 17.6472 7.03343 17.9669C7.35309 18.2865 7.78665 18.4661 8.23873 18.4661H16.7615C17.2135 18.4661 17.6471 18.2865 17.9667 17.9669C18.2864 17.6472 18.466 17.2136 18.466 16.7616V13.9917C18.466 13.8222 18.3987 13.6596 18.2788 13.5397C18.1589 13.4198 17.9963 13.3525 17.8268 13.3525C17.6573 13.3525 17.4947 13.4198 17.3748 13.5397C17.2549 13.6596 17.1876 13.8222 17.1876 13.9917V16.7616C17.1876 16.8746 17.1427 16.983 17.0628 17.0629C16.9829 17.1428 16.8745 17.1877 16.7615 17.1877H8.23873ZM19.1308 9.67067C19.2437 9.54949 19.3051 9.38923 19.3022 9.22363C19.2993 9.05803 19.2322 8.90003 19.1151 8.78292C18.998 8.66581 18.84 8.59872 18.6744 8.5958C18.5088 8.59288 18.3485 8.65435 18.2274 8.76726L13.4904 13.5033L11.8941 11.8533C11.8359 11.7925 11.7662 11.7437 11.689 11.7099C11.6119 11.6761 11.5288 11.6578 11.4446 11.6562C11.3604 11.6546 11.2767 11.6696 11.1983 11.7005C11.1199 11.7313 11.0484 11.7773 10.9879 11.8359C10.9273 11.8945 10.879 11.9644 10.8455 12.0418C10.8121 12.1191 10.7943 12.2023 10.7932 12.2865C10.792 12.3707 10.8075 12.4543 10.8388 12.5326C10.8701 12.6108 10.9165 12.682 10.9754 12.7423L13.0234 14.8593C13.0823 14.9204 13.1528 14.9692 13.2308 15.0028C13.3088 15.0363 13.3927 15.054 13.4776 15.0548C13.5625 15.0556 13.6467 15.0395 13.7253 15.0074C13.8038 14.9753 13.8753 14.9278 13.9353 14.8678L19.1308 9.67067Z",
    fill: "#3A9D18"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1194_1778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.6364,
    height: 13.6364,
    fill: "white",
    transform: "translate(5.68188 5.68176)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskIcon);
export default __webpack_public_path__ + "static/media/taskIcon.b243896ce20fd9fea9f634a359f8d347.svg";
export { ForwardRef as ReactComponent };